import { OccType } from '@/config/constant';
import { ReducerState } from '@/redux/reducers/reservation/checkIn';
import {
  customerValidator,
  rentTimeValidator,
  channelValidator,
  rentRoomValidator,
} from '@/pages/reservation/checkIn/validator';
import { ValidateSchema, createValidator } from '@/pages/reservation/utils/validator';

const allGuestList: (value: ReducerState['allGuestList'], data: ReducerState) => void = (
  value,
  data,
) => {
  customerValidator(value, {
    isAppendMode: !!data.commonInfo.appendOrderId,
    rentRoomList: data.rentRoomInfos || [],
  });
};

const commonInfo: (value: ReducerState['commonInfo'], data: ReducerState) => void = (
  value,
  data,
) => {
  const { dayTypeTimeInfo, hourTypeTimeInfo } = data;
  const { occType } = value;
  const rentTimeInfo = occType === OccType.DayUse ? dayTypeTimeInfo : hourTypeTimeInfo;
  rentTimeValidator(rentTimeInfo);
};

const channelInfo: (value: ReducerState['channelInfo'], data: ReducerState) => void = (
  value,
  data,
) => {
  channelValidator(value, data);
};

const rentRoomInfos: (value: ReducerState['rentRoomInfos'], data: ReducerState) => void = (
  value,
  data,
) => {
  rentRoomValidator(value, {
    categoryList: data.allRoomList || [],
  });
};

const mainSchema: ValidateSchema<ReducerState> = {
  allGuestList,
  channelInfo,
  commonInfo,
  rentRoomInfos,
};

export default createValidator<ReducerState>(mainSchema);
